import SubPage from "../components/SubPage";

export default function Installers() {
  return (
    <SubPage tKey="ds.page_installers" image="/img/marbella-villa.jpg"
      sections={[
        { title: "ds.page_installers.s1_title", body: "ds.page_installers.s1_body" },
        { title: "ds.page_installers.s2_title", body: "ds.page_installers.s2_body",
          bullets: ["ds.page_installers.s2_b1","ds.page_installers.s2_b2","ds.page_installers.s2_b3","ds.page_installers.s2_b4"] },
        { title: "ds.page_installers.s3_title", body: "ds.page_installers.s3_body" },
      ]} />
  );
}
